import { AbstractControl, ControlValueAccessor } from '@angular/forms';
import { AfterViewInit, Component, Input, Output, OnDestroy, ViewChild, EventEmitter } from '@angular/core';
import { LOCALIZED_CALENDAR_VALIDATOR, LOCALIZED_CALENDAR_VALUE_ACCESSOR } from './localized-calendar.providers';

import { Calendar } from 'primeng/primeng';
import { Subscription } from 'rxjs/Subscription';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'localized-calendar',
  templateUrl: './localized-calendar.component.html',
  styleUrls: ['./localized-calendar.component.css'],
  providers: [LOCALIZED_CALENDAR_VALUE_ACCESSOR, LOCALIZED_CALENDAR_VALIDATOR],
})
export class LocalizedCalendarComponent implements OnDestroy, AfterViewInit, ControlValueAccessor {

  @Input() placeholder = '';
  @Input() maxDate = null;
  @Input() showTime = false;
  @Input() yearNavigator = false;
  @Output() OnDateChanged = new EventEmitter<any>();
  @ViewChild(Calendar) calendarComponent: Calendar;

  private subscription: Subscription;
  es: any;

  constructor() {
    this.updateLocale();
  }

  writeValue(obj: any): void {
    this.calendarComponent.writeValue(obj);
  }
  registerOnChange(fn: any): void {
    this.calendarComponent.registerOnChange(fn);
  }
  registerOnTouched(fn: any): void {
    this.calendarComponent.registerOnTouched(fn);
  }
  setDisabledState(isDisabled: boolean): void {
    this.calendarComponent.setDisabledState(isDisabled);
  }
  validate(c: AbstractControl) {
    return this.calendarComponent.validate(c);
  }

  onSelect(event) {
    this.OnDateChanged.emit(event);
  }

  updateLocale() {

    this.es = {
      firstDayOfWeek: 1,
      dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
      dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
      dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
      monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
        'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
      monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
      today: 'Hoy',
      clear: 'Borrar'
    }

  }


  ngAfterViewInit() {
    setTimeout((_: any) => this.updateLocale());
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}




// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared/localized-calendar/localized-calendar.component.ts